import { FileText } from '@phosphor-icons/react';
import { Button } from 'src/components/Button';
import { Heading } from 'src/components/Heading';
import { ListNumbers } from './components/ListNumbers';
import { ContentWrapper } from 'src/components/ContentWrapper';

export const ManageNumbers = () => {
  return (
    <div className="flex-1">
      <Heading
        title="Numbers"
        subtitle="Phone numbers available for your account"
      >
        <div className="flex">
          <Button
            className="w-42 border-none flex items-center justify-center text-neutral-500"
            variant="outlined"
            color="default"
            href="https://docs.fluents.ai/api-reference/numbers"
            target="_blank"
          >
            View help doc
            <FileText className="ml-2" size={18} />
          </Button>
        </div>
      </Heading>

      <ContentWrapper>
        <ListNumbers />
      </ContentWrapper>
    </div>
  );
};
